import { useCallback } from 'react';
import { prop } from 'ramda';

import { useNavigateBare } from 'js/app/hooks/navigate/useNavigate/useNavigateBare';
import { useLoginPopup } from 'js/components/popups/LoginPopup/hooks';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

export const useNavigateWithCheckUser = ({ replace = false } = {}) => {
    const showLoginPopup = useLoginPopup();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const navigate = useNavigateBare({ replace });
    const menuItemsOnlyIsLoggedIn = useAppSelector(prop('menuItemsOnlyIsLoggedIn'));

    return useCallback((path, state, { removeParams = [], preserveSearchParams = true } = {}) => {
        if (!path) {
            return;
        }

        const handlerNavigate = () => navigate(path, state, { removeParams, preserveSearchParams });

        if (!isLoggedIn && menuItemsOnlyIsLoggedIn?.[path]) {
            showLoginPopup({
                onLogin: handlerNavigate
            });

            return;
        }

        handlerNavigate();

    }, [isLoggedIn, menuItemsOnlyIsLoggedIn, navigate, showLoginPopup]);
};

